// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'key-mirror';

export default keyMirror({
    POST_LIST_SCROLL_CHANGE: null,
});
